import { Model } from "@vuex-orm/core";
import SubscriptionType from "./SubscriptionType";
import { PhoneNumberDisplayFormat } from "../helpers/phoneNumberFormatter";

export default class Account extends Model {
  static entity = "accounts";
  
  static fields() {
    return {
      id: this.attr(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
      name: this.attr(),
      externalId: this.attr(),
      primaryPhone: this.attr(),
    };
  }

  get formattedPhone() {
    return PhoneNumberDisplayFormat(this.primaryPhone);
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
